<template>
  <display-debug>
    <template #debugView>
      langCode {{langCode}}
    </template>
  </display-debug>

  <div
      v-show="editorObj.display.wysiwyg"
      ref="editorWrap"
      class="wysiwig-wrap"
      v-check-fullscreen
  >

    <!-- help window -->
    <div
        v-if="helpObj.display && displaySpecials.help"
        class="layer layer-top"
    >
      <div class="layer-wrap">
        <div class="layer layer-top center-center">
          <div class="modal form-wrap form-overflow">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ $t('wysiwyg.help.title') }}
                  </h5>
                  <button
                      @click.prevent="helpObj.display=false;"
                      type="button" class="btn-close btn-sm"
                  ></button>
                </div>

                <div class="modal-body">


                  <ul
                      v-if="
                        helpObj.data
                        && Object.entries(helpObj.data) > 1
                      "
                      class="nav"
                  >

                    <li
                        v-for="(section, s_index) in helpObj.data"
                        class="nav-item"
                    >
                      <a
                          @click.prevent="toogleHelpItem(s_index)"
                          :class="'nav-link' + (section.display? ' disabled': '')"
                          href="#"
                      >
                        {{$t(section.title)}} [sect title]
                      </a>
                    </li>
                  </ul>


                  <div
                      v-for="(section, s_index) in helpObj.data"
                  >
                    <div>
                      <div
                          v-if="section.display"
                          class="accordion"
                      >
                        <div
                            v-for="(item, i_index) in section.items"
                            class="accordion-item"
                        >
                          <h2 class="accordion-header">
                            <button
                                @click.preven="toogleHelpItem(s_index, i_index)"
                                :class="'accordion-button __collapsed'  + (item.display?'':' collapsed') "
                                type="button"
                                aria-expanded="false"
                            >
                              <i v-if="item.ico" :class="item.ico.class + ' me-2'"/>
                              <span class="fs-5"> {{$t(item.title)}}</span>
                            </button>

                          </h2>
                          <div
                              :class="'accordion-collapse' + (item.display?' open':' collapse')"
                          >
                            <div class="accordion-body">
                              {{$t(item.content)}}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layer layer-bottom background-fill">
          &nbsp;
        </div>
      </div>
    </div>
    <!-- help window end-->


    <!-- buttons start -->
    <div
        class="btns-wrap btn-nav-bar mb-4 "
    >
      <div class="d-flex flex-wrap align-items-center gap-1 w-100">
        <!-- -->
        <template
            v-for="(button, index) in buttons"
        >
          <div class="d-flex flex-wrap flex-grow-0 flex-shrink-1" >

            <div
              class="input-group"
            >
              <div
                  @click.prevent="!button.isActive?onButtonCreate(index): onButtonEdit(index);"
                  :class="'btn btn-sm btn-outline-secondary text-nowrap' + (button.isActive? ' active': '') + (button.isDisabled? ' disabled': '')"
              >
                <i
                    v-if="button.ico.class"
                    :class="button.ico.class"
                />
                <span
                    class="ms-1 d-none d-md-inline"
                >
                  {{$t(button.title)}}
                </span>
              </div>


              <div
                  v-if="button.isActive && button.dialog"
                  @click.prevent="onButtonEdit(index)"
                  class="btn btn-sm btn-outline-secondary"
              >
                <i class="bi bi-pen"/>
              </div>

              <template
                  v-if="button.isActive && button.editAction"
              >
                <template
                    v-for="(editAction, actionIndex) in button.editAction"
                >
                  <a
                      @click.prevent="callElementAction(index, actionIndex)"
                      href="#action"
                      class="btn btn-sm btn-outline-secondary "
                  >
                    <i
                        v-if="editAction.ico"
                        :class="editAction.ico.class + ' me-1'"
                    />
                    {{$t(editAction.title)}}

                  </a>

                </template>
              </template>
              <i
                  v-if="button.isActive"
                  @click.prevent="onButtonRemove(index)"
                  class="btn btn-sm btn-outline-secondary bi bi-x text-danger"
                  title="Odstanit element, obsah zustane"
              />
            </div>
          </div>
        </template>

        <template v-if="renderSpecialButtons">
          <div
              class="btn-group ms-auto"
          >
            <template
                v-for="(btn, index) in renderSpecialButtons"
            >
              <div
                @click.prevent="clickSpecialButton(btn.onClick)"
                class="btn btn-sm btn-outline-primary"
              >
                <i
                    v-if="btn.ico"
                    :class="btn.ico.class"
                ></i>
                <span
                    v-if="btn.title"
                    class="ms-1 d-none d-md-inline"
                >
                    {{ $t(btn.title) }}
                  </span>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>




    <div
        v-if="1==0"
        class="btns-wrap btn-nav-bar mb-1 "
    >
      <div
        id="maniBtn"
        class="bg-primary-subtle d-inline"
      >
      <template
          v-for="(button, index) in buttons"
      >
        <div
            class="input-group d-inline me-1 mb-2"
        >
          <div
              @click.prevent="onButtonCreate(index)"
              :class="'btn btn-sm btn-outline-secondary' + (button.isActive? ' active': '') + (button.isDisabled? ' disabled': '')"
              tabindex="0"
          >
            <i
                v-if="button.ico.class"
                :class="button.ico.class"
            />
            <span
                class="ms-1 d-none d-md-inline"
            >
                {{$t(button.title)}}
              </span>
          </div>

          <div
              v-if="button.isActive && button.dialog"
              @click.prevent="onButtonEdit(index)"
              class="btn btn-sm btn-outline-secondary"
          >
            <i class="bi bi-pen"/>
          </div>

          <template
              v-if="button.isActive && button.editAction"
          >
            <template
              v-for="(editAction, actionIndex) in button.editAction"
            >
              <a
                @click.prevent="callElementAction(index, actionIndex)"
                href="#action"
                class="btn btn-sm btn-outline-secondary "
              >
                <i
                    v-if="editAction.ico"
                    :class="editAction.ico.class + ' me-1'"
                />
                {{$t(editAction.title)}}

              </a>

            </template>
          </template>
          <i
              v-if="button.isActive"
              @click.prevent="onButtonRemove(index)"
              class="btn btn-sm btn-outline-secondary bi bi-x text-danger"
              title="Odstanit element, obsah zustane"
          />

        </div>

      </template>
      </div>
      <template v-if="renderSpecialButtons">
          <span
              class="me-2"
          >
            &nbsp;
          </span>
        <div
            id="specBtnWrap"
          class="d-inline me-auto bg-info"
        >

          <template
            v-for="(btn, index) in renderSpecialButtons"
        >
          <div
              v-if="btn.special"
              class="input-group d-inline me-1 mb-2"
          >

            <!---->
            <display-debug>
              <template #debugView>searchObj {{searchObj}}</template>
            </display-debug>


            <!-- searchPhrase -->
          </div>
          <div
              v-else
              class="input-group d-inline me-1 mb-1 "

          >
              <span
                  class="btn btn-sm btn-outline-primary mb-1 mt-1"
                  @click.prevent="clickSpecialButton(btn.onClick)"
              >
                 <i
                     v-if="btn.ico"
                     :class="btn.ico.class"
                 ></i>
                  <span
                      v-if="btn.title"
                      class="ms-1 d-none d-md-inline"
                  >
                    {{ $t(btn.title) }}
                  </span>
              </span>
          </div>
        </template>
        </div>

      </template>
    </div>
    <!-- buttons end -->

    <div
        class="content-wrap "
    >
      <!-- dialog -->
      <div
          v-if="dialog && dialog.display"
          class="layer layer-top"
      >
        <div class="layer-wrap">
          <div class="layer layer-top center-center">
            <div class="modal form-wrap form-overflow">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{$t(dialog.title)}}</h5>
                    <button
                        @click.prevent="closeDialog();"
                        type="button" class="btn-close btn-sm"
                    ></button>
                  </div>
                  <div class="modal-body">

                    <template
                      v-if="dialog.is_loading"
                    >
                      <div class="d-flex justify-content-center p-3">
                        <div class="spinner-border text-secondary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </template>

                    <div
                        v-if="dialog.validation && dialog.validation.error"
                        class="text-danger text-center py-2"
                    >
                      <i class="bi bi-exclamation-triangle-fill me-2"/>
                      {{dialog.validation.error}}
                    </div>

                    <!-- TODO innerHTML -->
                    <div
                      v-if="dialog.isWrap"
                    >
                      <label class="input-group-text">{{ $t('wysiwyg.action.link.dialog.marked_text.title') }}</label>
                      <div
                          ref="dialogWrappedInput"
                          contenteditable="true"
                          class="cms-form-input-oneline form-control"
                          style="height: 2.5rem; min-height: 2.5rem;"
                          data-name="dialog.innerHTML"
                          @input="updateDialogWrapped($event)"
                      />


                      <!--
                      <div
                          contenteditable="true"
                          class="cms-form-input-oneline form-control"
                          style="height: 2.5rem; min-height: 2.5rem;"
                          data-name="dialog.innerHTML"
                          @input="updateDialogWrapped($event)"
                          v-html="dialog.wrapped"
                      />
                     -->
                    </div>



                    <!-- v-html="dialog.wrapped" -->


                    <div
                        v-for="(item, index) in dialog.inputs"
                    >
                      <!--
                    <pre>
                      (this.dialog.values) value [{{index}}]: {{dialog.values[index]}}
                    </pre>
                      -->
                      <template
                          v-if="item.type == 'text'"
                      >
                        <div
                            class="input-group mb-2"
                        >
                          <label class="input-group-text">{{ $t(item.title) }}</label>
                          <input
                              type="text"
                              v-model="dialog.values[index]"
                              :required="item.isMandatory? 'required': ''"
                              :placeholder="(item.placeholder && $t(item.placeholder)? $t(item.placeholder): '')"
                              class="form-control"
                              @input="onDialogInputActions($event, 'input', item.action)"
                              @keydown.enter.prevent="onKeyDownReloadDialog($event, item)"
                          />

                          <template
                            v-if="item.is_refresh"
                          >
                            <a
                              @click.prevent="reloadDialog();"

                              href="#reloadDialog"
                              class="btn "
                            >
                              <i
                                  :class="item.is_refresh.ico"
                                  :title="item.is_refresh.title"
                              />
                            </a>
                          </template>
                        </div>

                      </template>
                      <template
                          v-else-if="item.type == 'textarea'"
                      >
                        <div
                            class="input-group mb-2"
                        >
                          <label class="input-group-text">{{ $t(item.title) }}</label>
                          <textarea
                              type="text"
                              v-model="dialog.values[index]"
                              :required="item.isMandatory? 'required': ''"
                              :placeholder="(item.placeholder && $t(item.placeholder)? $t(item.placeholder): '')"
                              class="form-control"
                              @input="onDialogInputActions($event, 'input', item.action)"
                          />
                        </div>
                      </template>
                      <template
                          v-else-if="item.type == 'select'"
                      >
                        <div
                            class="input-group mb-2"
                        >
                          <label class="input-group-text">{{$t(item.title)}}</label>
                          <select
                              v-model="dialog.values[index]"
                              class="form-select"
                          >
                            <option
                                v-for="(option, index) in item.select"
                                :value="index"
                            >
                              {{$t(option.title)}}
                            </option>
                          </select>
                        </div>
                      </template>
                      <template
                          v-else-if="item.type == 'bool'"
                      >
                        <div
                            class="form-check form-switch mb-2"
                        >
                          <input
                              v-model="dialog.values[index]"
                              :id="'special_dialog_' + index"
                              type="checkbox"
                              :placeholder="($t(item.placeholder)? $t(item.placeholder): '[placeholder]')"
                              class="form-check-input"
                              value="1"
                              @input="onDialogInputActions($event, 'input', item.action)"
                          >
                          <label
                              :for="'special_dialog_' + index"
                              class="form-check-label"
                          >
                            {{$t(item.title)}}
                          </label>
                        </div>
                      </template>
                      <template
                          v-else-if=" 1 == 1 && item.type == 'btn_submit' "
                      >
                        <div
                            class="-btn-group mb-2"
                        >

                          <div
                            v-if="item.content && Object.entries(item.content).length > 0"
                          >
                            <template
                                v-for="(btn) in item.content"
                            >
                              <div
                                  :class="'btn me-1 ' + ((dialog.values[index] && dialog.values[index] == btn.id)? 'btn-primary': 'btn-outline-primary')"
                                  @click.prevent="dialog.values[index]=btn.id; submitDialog();"
                              >
                                <!-- -->
                                <span
                                    v-if="dialog.values[index] && btn.id == dialog.values[index].id"
                                >
                                <i class="bi bi-check me-2"/>
                              </span>


                                <!--  @click.prevent="dialog.values[index]=btn.value;submitDialog();" -->
                                {{ $t(btn.title) }}
                              </div>
                            </template>
                          </div>
                          <div
                            v-else
                            class="text-danger text-center"
                          >
                            {{item.options.empty.title}}
                          </div>
                        </div>
                      </template>

                      <template
                          v-else
                      >
                        <display-debug>
                          <template #debugView>input item bez definice {{item}}</template>
                        </display-debug>
                      </template>

                      <div
                          v-if="item.err"
                          class="text-danger mb-2"
                      >
                        <i class="bi bi-exclamation-triangle me-1"></i>{{item.err}}
                      </div>
                    </div>
                  </div>

                  <div
                      v-if="dialog.btn_footer"
                      class="modal-footer"
                  >
                    <template
                      v-if="dialog.btn_footer.reset"
                    >
                      <button
                        @click.prevent="resetDialog()"
                        type="reset"
                        :class="dialog.btn_footer.reset.class"
                      >
                        {{dialog.btn_footer.reset.title}}
                      </button>
                    </template>

                    <template
                        v-if="dialog.btn_footer.submit"
                    >
                      <button
                          @click.prevent="submitDialog()"
                          type="submit"
                          :class="dialog.btn_footer.submit.class"
                      >
                        <i class="bi bi-check2"></i>
                        {{dialog.btn_footer.submit.title}}
                      </button>
                    </template>

                    <!--
                    <button
                        @click.prevent="submitDialog()"
                        class="btn btn-sm btn-success me-2"
                    >
                      <i class="bi bi-check2"></i> {{ $t('wysiwyg.dialog.submit.title') }}
                    </button>
                    -->


                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="layer layer-bottom background-fill">
            &nbsp;
          </div>
        </div>
      </div>
      <!-- dialog end-->
      <div
          class="layer layer-bottom p-1 form-parent"
      >
        <div
            ref="editorWysiwygBody"
            contenteditable="true"
            class="editor-body form-control p-3"

            @mouseup="saveSelection()"
            @keydown="onKeydown($event);"
            @keyup="saveSelection(); onKeyup($event); onElementCursor();"
            @input="saveSelection(); onWysiwygUpdate(); "
            @click=" saveSelection(); onElementSelect($event);"
            @focusout="clearElementHightlight($refs.editorWysiwygBody); onWysiwygUpdate(); htmlFormat();"
            @paste="onPaste"
            @contextmenu="onContextMenu($event)"
        ></div>
      </div>
    </div>



<!--

    <display-debug>
      <template #debugView>dialog {{dialog}}</template>
    </display-debug>

    <display-debug>
      <template #debugView>buttons {{buttons}}</template>
    </display-debug>
    -->
  </div>

  <div
      v-show="editorObj.display.code"
      class="html-wrap"
  >

    <span
        class="btn btn-sm btn-outline-primary mb-1"
        @click.prevent="switchEditor()"
    >
      <i class="bi bi-easel"></i>
      {{ $t('wysiwyg.code_editor.editor.title') }}
    </span>

    <textarea
        ref="editorCode"
        v-model="editorObj.data.code"
        class="form-control html-code"
        @input="onHtmlFormat(); onHtmlUpdate()"
        @focus="htmlFormat()"
    />
    <template
      v-if="htmlEditor.error"
    >
      <div
          class="alert alert-danger mt-2"
      >
        <i class="bi bi-exclamation-triangle-fill me-2"/>
        <span>{{htmlEditor.error}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import {defaultEditorConfig} from "./htmlEditorConfigDefault.js";
import  "./htmlEditor.scss";
//import {type} from "@vueuse/core/index";
import axios from "axios";
import general from "@/components/config/general";
import prettier from 'prettier/standalone';
import parserHtml from 'prettier/plugins/html';
import "./htmlEditor.scss"
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
export default {
  name: "htmlEditor v3",
  components: {
    prettier,
    parserHtml,
  },
  props: {
    "modelValue": {
      type: [String, Number, Object],
      required: false,
    },
    "inputData": {
      type: [String, Number, Object],
      required: false,
    },
    "editorType": {
      type: [String, Number],
      required: false,
      default: null,
    },
    "langCode": {
      type: [String],
      required: false,
      default: 'xx',
    },
    "editorConfig": {
      type: [Object, Array],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
      default: {
        attributes: {
          element_id_name: 'data-cms-element-id',
          element_typ_name: 'data-cms-element-type',
          element_values_name: 'data-cms-element-form-inputs',
        },
        action: {
          create: 'create',
          edit: 'edit',
          delete: 'delete',
        },
        timerObj: {
          mounted: null,
          renderDelay: null,
          onMounted: null,
          onClickLoadAttr: null,
          codeType: null,
          clearCode: null,
        },
        timer: {
          renderDelay: 10,
          onMounted: 5,
          onClickLoadAttr: 1,
          codeType: 500,
          clearCode: 750,
        }
      }
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: null,
      savedRange: null,
      selectedElement: {
        tagName: null,
        element: null,
      },
      htmlEditor: {
        error: null,
      },
      editorObj: {
        is_wysiwyg_focus: true,
        data: {
          code: null,
          wysiwyg: null,

        },
        display: {
          code: false,
          wysiwyg: true,
          code_timer: null,
          code_error: null,
        }
      },
      buttons: {},
      specialButtons: {},
      dialog: { // todo struktura
          display: false,
          title: null,
          values: null,
          inputs: null,
          btn_footer: null,
          innerHTML: null,
          validation: null,
      },
      displaySpecials: { //displaySpecials.removeElement
        clearFormatComplete: true,
        cleanCode: true,
        removeElement: false,
        fullscreenToggleOn: true,
        fullscreenToggleOff: false,
        switchEditorToCode: true,
        search: false,
        help: true,
      },
      searchObj: {
        display: false,
        model: '',
        phrase: null,
        replacePhrase: null,
        resultIndex: null,
        results: null,
        isReplacement: false,
        err: null,
      },
      helpObj: {
        display: false,
        data: false,
      },
      customButtonsDefinition: null,
    }
  },
  created() {
    //console.clear() //DEV
  },
  mounted() {
    this.copySourceToEditorCustom();
    this.$nextTick(() => {
      //console.log('-- [htmlEditor3.mounted] -- ' + this.langCode + ' - ' + this.instanceId + ' --------------------------------');
      this.prefillData();
      this.loadCustomButtons();
      this.updateButtons();
      //this.updateSpecialButtonDisplay();
      this.isHelpObj();
    });

    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
  },
  unmounted() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
  },
  directives: {
    'checkFullscreen': { beforeMount(el, binding) {
        const componentInstance = binding.instance;
        el.checkFullscreen = () => {
          if (!document.fullscreenElement) {
            componentInstance.displaySpecials.fullscreenToggleOn = true;
            componentInstance.displaySpecials.fullscreenToggleOff = false;
          }
        };
        document.body.addEventListener('fullscreenchange', el.checkFullscreen);
      },
      unmounted(el) {
        document.body.removeEventListener('fullscreenchange', el.checkFullscreen);
      }
    },
  },

  computed: {
    renderSpecialButtons() {
      const buttons = {};
      const specials = this.specialButtons;

      for(const i in specials) {
        //console.log('[htmlEditor.renderSpecialButtons]', i, this.specialsDefinition[i]);
        if(
            this.isDisplaySpecialButton(
                i,
                (typeof specials[i].displayMethod != "undefined"? specials[i].displayMethod: null)
            )
        ) {
          buttons[i] = specials[i];
        }

      }

      if(Object.keys(buttons).length > 0) {
        return buttons;
      } else{
        return null;
      }
    }
  },
  methods: {
    saveSelection() {
      const sel = window.getSelection();
      if (sel.rangeCount > 0) {
        this.savedRange = sel.getRangeAt(0).cloneRange();
      }
    },
    saveElementRange(element = null, applySelection = false) {
      const targetElement = element || this.selectedElement?.element;

      if (!targetElement) {
        return false;
      }

      const range = document.createRange();
      range.selectNodeContents(targetElement);

      this.savedRange = range.cloneRange();

      if (applySelection) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }

      return true;
    },

    isRangeNotEmpty() {
      return !(this.savedRange && this.savedRange.collapsed);
    },

    getRangeHtml() {
      const range = this.savedRange;
      const fragment = range.cloneContents();
      const div = document.createElement("div");
      div.appendChild(fragment);
      return div.innerHTML;
    },

    insertBreak() {
      if (!this.savedRange) return;

      const range = this.savedRange;
      const br = document.createElement("br");

      range.deleteContents();
      range.insertNode(br);
      range.collapse(false);

      this.restoreCursorAfter(br);
    },

    wrapSelection(tagName) {
      if (!this.savedRange) return;

      const range = this.savedRange;

      if (range.collapsed) return; // nic nevybráno

      const wrapper = document.createElement(tagName);
      wrapper.appendChild(range.extractContents());
      range.insertNode(wrapper);

      this.restoreCursorAfter(wrapper);
    },

    restoreCursorAfter(el) {
      const range = document.createRange();
      const sel = window.getSelection();

      range.setStartAfter(el);
      range.collapse(true);

      sel.removeAllRanges();
      sel.addRange(range);

      this.savedRange = range.cloneRange();
    },

    onKeydown(event) {
      //console.log('[htmlEditor.applyKeyup]', event);

      if(
          event.keyCode == 13

      ) {
        event.preventDefault();
        if(
            this.selectedElement.tagName == 'li'
            && event.ctrlKey == false
        ){
          //novy seznam - polozka
          const newLi = document.createElement("li");

          if(
              this.selectedElement.element.parentNode
              && this.selectedElement.element.nextSibling
          ){
            this.selectedElement.element.parentNode.insertBefore(newLi, this.selectedElement.element.nextSibling);

            //reset cursor
            this.setCursorToEnd(newLi);
          }
        }else{
          //obycejny br
          this.insertBreak();
        }
        //console.log('[htmlEditor.applyKeyup] ENTER',);
      }
    },

    setCursorToEnd(el) {
      const range = document.createRange();
      const sel = window.getSelection();

      range.selectNodeContents(el);
      range.collapse(false); // false = konec obsahu

      sel.removeAllRanges();
      sel.addRange(range);
    },

    onKeyup(event) {

    },

    onHtmlUpdate(){
      this.$refs.editorWysiwygBody.innerHTML = this.editorObj.data.code;
    },
    onWysiwygUpdate(){
      try {
        this.editorObj.data.code = this.$refs.editorWysiwygBody.innerHTML;
      }catch (e) {
        console.error('onWysiwygUpdate', e)
      }

    },

    onHtmlFormat() {
      if(this.editorObj.display.code_timer) clearInterval(this.editorObj.display.code_timer);
      this.editorObj.display.code_timer = setTimeout(
          () => {
            this.htmlFormat()
          },
          1000
      )
    },

    async htmlFormat() {

      try {
        const elRef = this.$refs.editorCode;
        const startPos = elRef.selectionStart;
        const endPos = elRef.selectionEnd;

        this.editorObj.data.code  = await prettier.format(this.editorObj.data.code , {
          parser: 'html',
          plugins: [parserHtml],
          tabWidth: 4,
          printWidth: 128
        });

        this.htmlEditor.error = null;
        this.$nextTick(() => {
          //elRef.focus();
          elRef.setSelectionRange(startPos, endPos);
        });

      } catch (error) {
        this.htmlEditor.error = error;
        //console.error("Chyba při formátování HTML:", error);
      }
    },

    setActiveElement(el) {
      if(el) {
        this.selectedElement = {
          tagName: el.tagName.toLowerCase(),
          element: el,
        };
      }else{
        this.selectedElement = {
          tagName: null,
          element: null,
        };
      }
      /*
      console.log(
          "[htmlEditor.setActiveElement]",
          el.tagName.toLowerCase(),
          el.outerHTML,
      );

       */
    },

    onElementSelect(event) {
      //console.log("dev onEditorClick", event);
      let el = event.target;

      // Je Root
      if(
          el.getAttribute("contenteditable")
      ) {
        this.setActiveElement(null);
        return false;
      }

      // Pokud klikneš na textový uzel, posuň se na parent element
      if (el.nodeType === Node.TEXT_NODE) {
        el = el.parentNode;
      }

      this.setActiveElement(el);

      this.clearElementHightlight(this.$refs.editorWysiwygBody);
      this.markElementHightlight(el);
    },

    onElementCursor() {
      const sel = window.getSelection();
      //console.log('dev onElementCursor', sel)
      //this.setActiveElement(null); //dev
      if (!sel.rangeCount) return;

      const range = sel.getRangeAt(0);
      let el = range.startContainer;

      if (el.nodeType === Node.TEXT_NODE) {
        el = el.parentNode;
      }

      this.setActiveElement(el);

      this.clearElementHightlight(this.$refs.editorWysiwygBody);
      this.markElementHightlight(el);
    },

    markElementHightlight(el) {
      el.classList.add("vue-app-highlighted-element");
    },

    clearElementHightlight(parent) {
      try {
        const elements = parent.querySelectorAll(".vue-app-highlighted-element");
        if(
            elements
        ){
          elements.forEach(el => {
            el.classList.remove("vue-app-highlighted-element");
          });
        }
      }catch (e) {
        console.error('dev clearElementHightlight', e)
      }
    },

    removeFormat() {
      //console.log('dev removeFormat', this.selectedElement);
      const el = this.selectedElement.element;
      const parent = el.parentNode;

      // 1) vezmeme textový obsah
      const textNode = document.createTextNode(el.textContent);

      // 2) nahradíme element textovým uzlem
      parent.replaceChild(textNode, el);

      // 3) přesuneme caret ZA vložený text
      const range = document.createRange();
      const sel = window.getSelection();

      range.setStartAfter(textNode);
      range.collapse(true);

      sel.removeAllRanges();
      sel.addRange(range);

      this.selectedElement = {
        tagName: null,
        element: null,
      };

    },

    switchEditor() {
      this.editorObj.display = {
        code: !this.editorObj.display.code,
        wysiwyg: !this.editorObj.display.wysiwyg,
      }
      this.editorObj.is_wysiwyg_focus = !this.editorObj.is_wysiwyg_focus
    },

    updateButtons() {
      this.buttons = {};
      let buttons = Object.assign(defaultEditorConfig.buttonsDefinition.default);

      if(
          this.editorConfig
          && this.editorConfig.config
          && this.editorConfig.config.buttons
          && Object.keys(this.editorConfig.config.buttons).length > 0
      ) {
        for(const b in buttons) {
          if(
              typeof this.editorConfig.config.buttons[b] !== "undefined"
          ) {
            Object.assign(
                buttons[b],
                this.editorConfig.config.buttons[b]
            );
          }else{
            delete buttons[b];
          }
        }
      }

      //special buttons
      this.specialButtons = defaultEditorConfig.specialsDefinition.default;
      if(this.customButtonsDefinition) {
        buttons = this.customButtonsDefinition;
      }

      //aktivni tlacitka
      let activeElement = null;
      //specials
      //li
      if(
          this.selectedElement.element
      ){
        activeElement = this.selectedElement.tagName;

        if(
            this.selectedElement.element.getAttribute(this.config.attributes.element_typ_name)
        ){
            activeElement = this.selectedElement.element.getAttribute(this.config.attributes.element_typ_name)
        }

        if (
            this.selectedElement.element.tagName.toLowerCase() == 'li'
        ){
          activeElement = this.selectedElement.element.parentNode.tagName.toLowerCase()
          //console.log('[htmlEditor.updateButtons] LI', this.selectedElement.element.parentNode.tagName.toLowerCase()   )

        }else if(
            this.selectedElement.element.tagName.toLowerCase() == 'td'
        ){
          activeElement = 'table'
          //console.log('[htmlEditor.updateButtons] TD', this.selectedElement.element.parentNode.tagName.toLowerCase()   )
        }
      }


      if(activeElement) {
        //attributes
        //console.log('[htmlEditor.updateButtons] activeElement', activeElement, this.config.attributes.element_typ_name) // attributes.element_typ_name
      }

      //console.log('[htmlEditor.updateButtons] this.savedRange', this.savedRange)
      for(const i in buttons) {
        //nastnaveni moznosti
        if(
            buttons[i].isWrap == true
            && this.isRangeNotEmpty()
        ) {
          buttons[i].isDisabled = false;
          //
        } else if(
            buttons[i].isWrap == false
            && !this.isRangeNotEmpty()
        ) {
          buttons[i].isDisabled = false;
        }else{
          buttons[i].isDisabled = true;
        }

        //editacni tlacitka
        buttons[i].isActive = false;


        if(
          activeElement
          && activeElement == i
        ) {
          buttons[i].isActive = true;
          buttons[i].isDisabled = false;
        }

        if(
            this.selectedElement.element
            && 1 == 0
        ) {

          //console.log('[htmlEditor.updateButtons] DEV', this.selectedElement.element.tagName.toLowerCase(), i )
          //console.log('[htmlEditor.updateButtons] DEV', this.selectedElement.element.tagName , this.selectedElement.element.getAttribute('data-element-ident') )
          //, this.selectedElement.element.getAttribute('data-element-ident'),
          if(
              this.selectedElement.element.tagName.toLowerCase() == i
          ) {
            //console.log('[htmlEditor.updateButtons] SELECT', this.selectedElement.element.tagName.toLowerCase(), i )
            buttons[i].isActive = true;
            buttons[i].isDisabled = false;
          }else{
            //buttons[i].isActive = false;
          }
        }else{
          //buttons[i].isActive = false;
        }


        /*
                if(
                    this.selectedElement.tagName == buttons[i].tagName // TODO lepsi idetifikace skrz dataset s i
                ) {
                  buttons[i].isActive = true;
                }else{
                  buttons[i].isActive = false;
                }
                */
        //console.log('[htmlEditor.updateButtons] button', i, buttons[i].tagName, buttons[i].isActive, buttons[i].isDisabled)
        //console.log('[htmlEditor.updateButtons] button', i, buttons[i].tagName, this.selectedElement.tagName)
      }




      //output
      this.buttons = buttons;
    },

    onButtonCreate(ident) {
      //console.log('[htmlEditor.onButtonCreate] ident', ident);
      const range = this.savedRange;
      /*
      if (range.collapsed) {
        console.log('[htmlEditor.onButtonCreate] collapsed');
      };
*/




      const elementInfo = this.buttons[ident];
      let attributes = {};

      //console.log('[htmlEditor.onButtonCreate] elementInfo', elementInfo);
      //dialog
      if(elementInfo.dialog) {
        this.openDialog(
            ident,
            elementInfo
        );
      }else{
        const el = this.createHtmlElement(ident, elementInfo, attributes);
        this.insertElement(elementInfo, el);
      }
    },



    createDialogDynamic(config) {
      let formData = new FormData();
      formData.append('subject', this.getRangeHtml());
      formData.append('wrapped_text', this.getRangeHtml());
      formData.append('lang_code', this.langCode);
      if(
          this.dialog.values
      ) {
        formData.append('dialog_values', JSON.stringify(this.dialog.values));
      }
      this.dialog.is_loading = true;

      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        method: 'post',
        url: config.path,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        for(const i in res.data.response.form.inputs) {
          if(
              !this.dialog.values[i]
          ){
            this.dialog.values[i] = res.data.response.form.inputs[i].value;
          }
        }
        this.dialog.inputs = res.data.response.form.inputs;

        this.dialog.btn_footer = res.data.response.form.btn_footer;

      }).catch(function(err){
        //this.dialog.is_loading = false;
        console.error('[htmlEditor.loadInputsFromBackend] ERR', err)
      }).finally((data) =>{
        //this.sendDataToDialog();
        this.dialog.is_loading = false;
        this.dialog.display = true;
      })
    },

    onKeyDownReloadDialog(event, input) {
      if(
          input.is_refresh
      ){
        this.reloadDialog();
      }
    },

    reloadDialog() {
      const elementData = this.buttons[this.dialog.buttonIndex]; //
      //console.log('[htmlEditor.reloadDialog]', this.dialog.buttonIndex, elementData)
      this.openDialog(
          this.dialog.buttonIndex,
          elementData,
          this.dialog.values,
      );
    },

    openDialog(
        index,
        elementData,
        data = null
    ) {
      //console.log('[htmlEditor.openDialog] ', index, elementData, data)
      //console.log('[htmlEditor.openDialog] dialog', this.dialog)

      const dialog = {
        display: true,
        title: elementData.dialog.title,
        btn_footer: elementData.dialog.btn_footer,
        values: {},
        buttonIndex: index,
        definiton: elementData,
        error: null,
        index: index,
        is_loading: false,
      };

      //console.log('[htmlEditor.openDialog] ', elementData.dialog, elementData)
      if(
          typeof elementData.dialog.config != "undefined"
          && typeof elementData.dialog.config.methods != "undefined"
      ) {
        dialog.methods = elementData.dialog.config.methods


        //console.log('[htmlEditor.openDialog] ', elementData)

        this.createDialogDynamic(elementData.dialog.config.methods.paths.display);


        if(
            this.selectedElement
            && this.selectedElement.element
            && this.selectedElement.element.getAttribute('data-cms-element-value')
        ){
          //console.log('[htmlEditor.openDialog] loadded data', this.selectedElement.element.getAttribute('data-cms-element-value'))
          dialog.values = JSON.parse(
              this.selectedElement.element.getAttribute('data-cms-element-value')
          );
        }

        if(data){
          for(const i in data) {
            dialog.values[i] = data[i];
          }
        }

      } else if(typeof elementData.dialog.inputs != "undefined") {
        dialog.display = true;

        if(elementData.isWrap == true){
          dialog.isWrap = true;
          dialog.wrapped = this.getRangeHtml()
        }
        dialog.inputs = elementData.dialog.inputs


        //Nacitani
        //console.log('[htmlEditor.openDialog] elementData.dialog.inputs', elementData.dialog.inputs)

        for(const i in elementData.dialog.inputs) {
            if(
                typeof elementData.dialog.inputs[i].defaultValue != "undefined"
                && typeof elementData.dialog.inputs[i].defaultValue != "undefined"
            ) {
              dialog.values[i] = elementData.dialog.inputs[i].defaultValue;
            }else{
              dialog.values[i] = null;
            }
        }
      }

      const is_loading = this.dialog.is_loading;


      this.dialog = dialog;
      this.dialog.is_loading = is_loading;

      this.$nextTick(() => {
        if (
            this.dialog.isWrap
            && this.$refs.dialogWrappedInput
        ) {
          this.$refs.dialogWrappedInput.innerHTML = this.dialog.wrapped || '';
        }
      });
    },


    onDialogInputActions(event, type, actions){
      try {
        if(
            actions
            && typeof actions[type] != "undefined"
            && actions[type]
        ) {
          for(const action of actions[type]) {
            if(typeof this[action] == 'function') {
              this[action]();
            }else{
              console.error('Neexistuje metoda', action)
            }
          }
        }
      }catch (e) {
        console.error('onDialogInputActions', e)
      }
    },

    updateDialogWrapped(event){
      //TODO delay
      this.dialog.wrapped = event.target.innerHTML;
    },

    updateHtmlElement() {
      //console.log('[htmlEditor.updateHtmlElement] ', this.dialog.wrapped, this.dialog.values)
      if(
          this.selectedElement
          && this.selectedElement.element
      ) {
        for(const i in this.dialog.values) {
          console.log('[htmlEditor.updateHtmlElement] ', i, this.dialog.values[i])
          if(
              this.dialog.values[i]
          ) {
            this.selectedElement.element.setAttribute(i, this.dialog.values[i]);
          }else{
            this.selectedElement.element.removeAttribute(i);
          }
        }
        if(
            this.dialog.wrapped
        ){
          this.selectedElement.element.innerHTML = this.dialog.wrapped;
        }
      }

      //reset
      const range = document.createRange();
      const sel = window.getSelection();

      range.setStartAfter(this.selectedElement.element);
      range.collapse(true);

      sel.removeAllRanges();
      sel.addRange(range);
    },

    async updateHtmlElementDynamic() {
      const formData = new FormData();
      formData.append('request', 'generate');
      formData.append('inputs', JSON.stringify(this.dialog.values));
      formData.append('lang_code', this.langCode);

      axios.defaults.baseURL = this.getBaseRoot();

      try {
        // 2. Počkáme na výsledek axiosu pomocí await
        const res = await axios({
          url: this.dialog.methods.paths.generate.path,
          method: this.dialog.methods.paths.generate.method,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        });

        //console.log('[htmlEditor.updateHtmlElementDynamic] RES', res)


        if(
            res.data.response.element.innerHTML
        ){
          this.selectedElement.element.innerHTML = res.data.response.element.innerHTML;
        }

        if(
            typeof res.data.response.element.render_attr != "undefined"
        ) {
          for (const i in res.data.response.element.render_attr) {
            this.selectedElement.element.setAttribute(i, res.data.response.element.render_attr[i]);
          }
        }


        //return res.data.response.element;

      } catch (err) {
        console.log('[htmlEditor.updateHtmlElementDynamic] ERR', err);
        throw err; // Propagujeme chybu, aby na ni mohl reagovat i loadWrap
      }
      console.log('[htmlEditor.updateHtmlElementDynamic] ')
    },

    async resetDialog() {
      this.dialog.validation = null;
      for(const i in this.dialog.inputs) {
        this.dialog.values[i] = this.dialog.inputs[i].value;
      }
    },


    async submitDialog() {
      console.log('[htmlEditor.submitDialog] ', this.dialog)
      if(
          this.dialog.action == 'edit'
      ){
        if(
              typeof this.dialog.methods != "undefined"
              && typeof this.dialog.methods.paths.generate != "undefined"
        ){
          this.updateHtmlElementDynamic();
        }else{
          this.updateHtmlElement();
        }
        this.closeDialog();
      }else{
        if(
            typeof this.dialog.methods != "undefined"
            && typeof this.dialog.methods.paths.generate != "undefined"
        ){
          //this.generateDynamicHtmlElement();
          //console.log('[htmlEditor.submitDialog] DIALOG ',  this.dialog)

          try {
            // Klíčové slovo 'await' zajistí, že skript počká, dokud se data nestáhnou
            const data = await this.generateDynamicHtmlElement();


            if(
              this.dialog.validation
                && this.dialog.validation.status == false
            ){
              console.log("dev submitDialog: ERR", this.dialog.validation);
            }else{
              //ok

              if (data) {
                const el = this.createHtmlElementDynamic(
                    this.dialog.buttonIndex,
                    data
                );
/*
                if(
                    this.dialog.definiton.isTextOnly
                ) {
                  console.log("dev submitDialog: TEXT", this.dialog.definiton);
                }
*/
                this.insertElement(this.dialog.definiton, el);

                //this.setActiveElement(el)
                this.setCursorToEnd(el);

                this.insertText(' ', false);

                // Zde proveďte vaši logiku (např. if (data.status === 'ok') { ... })
              } else {
                console.log("Data jsou prázdná");
              }
              //close dialog
              this.dialog.display = false;
              this.dialog.definiton = null;
              this.dialog.index = null;
            }



          } catch (error) {
            console.error("Zpracování selhalo kvůli chybě v loadGenData");
          }


/*
          if(
              this.dialog.generated
          ) {
            console.log('[htmlEditor.submitDialog] DIALOG ELEM DATA 2', this.dialog.generated )
          }
*/
        }else{
          //normani vlozeni
          const el = this.createHtmlElement(
              this.dialog.index,
              this.dialog.definiton,
              this.dialog.values
          );
          if(
              this.dialog
              && this.dialog.wrapped
          ){
            el.innerHTML = this.dialog.wrapped;
          }

          console.log('[htmlEditor.submitDialog] DIALOG ELEM SIMPLE', this.dialog.definiton, el)
          this.insertElement(this.dialog.definiton, el);

          //close dialog
          this.dialog.display = false;
          this.dialog.definiton = null;
          this.dialog.index = null;
        }
      }
    },


    async generateDynamicHtmlElement() { // 1. Přidáno async
      const formData = new FormData();
      formData.append('request', 'generate');
      formData.append('inputs', JSON.stringify(this.dialog.values));
      formData.append('lang_code', this.langCode);
      axios.defaults.baseURL = this.getBaseRoot();

      try {
        // 2. Počkáme na výsledek axiosu pomocí await
        const res = await axios({
          url: this.dialog.methods.paths.generate.path,
          method: this.dialog.methods.paths.generate.method,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        });

        // validace
        if(
            res.data.response.validation
        ) {
          this.dialog.validation = res.data.response.validation;
          console.log('[htmlEditor.generateDynamicHtmlElement] RES valida', res.data.response.validation);
        }else{
          this.dialog.validation = null;
        }



        //this.dialog.generated = res.data.response.element;
        return res.data.response.element;

      } catch (err) {
        console.log('[htmlEditor.loadCustomButtons] ERR', err);
        throw err; // Propagujeme chybu, aby na ni mohl reagovat i loadWrap
      }
    },

    async generateDynamicHtmlElement1() {
      //console.log('[htmlEditor.generateDynamicHtmlElement] ', this.dialog.values)
      const formData = new FormData();
      formData.append('request', 'generate');
      formData.append('inputs', JSON.stringify(this.dialog.values));
      let output ={ init: true};
      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        url: this.dialog.methods.paths.generate.path,
        method: this.dialog.methods.paths.generate.method,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('[htmlEditor.generateDynamicHtmlElement] RES',  res.data.response.element)
        //output = res.data.response.element
        return res.data.response.element;
        this.dialog.generated = res.data.response.element;

        //return res.data.response.element;
      }).catch(function(err){
        console.log('[htmlEditor.loadCustomButtons] ERR',  err )
      })
      //console.log('[htmlEditor.generateDynamicHtmlElement] OUT',  output )
      //return output;
     },


    onButtonEdit(ident) {
      //console.log('[htmlEditor.onButtonEdit] ', ident)
      const range = this.savedRange;
      if (range.collapsed) {
        //console.log('[htmlEditor.onButtonEdit] collapsed');
      };

      const elementInfo = this.buttons[ident];
      let attributes = {};

      //console.log('[htmlEditor.onButtonCreate] elementInfo', elementInfo);
      //dialog
      if(elementInfo.dialog) {
        this.openDialog(
            ident,
            elementInfo
        );
        //todo doplnit attr

        this.updateDialogValues(elementInfo.dialog.inputs);

      }
    },

    updateDialogValues(inputs){
      this.dialog.action = 'edit';
      this.dialog.wrapped = this.selectedElement.element.innerHTML;

      for (const n of this.selectedElement.element.getAttributeNames()) {
        this.dialog.values[n] = this.selectedElement.element.getAttribute(n);
      }
      for(const i in inputs) {
        this.dialog.values[i] = this.selectedElement.element.getAttribute(i);
      }
    },

    onButtonRemove(ident) {
        console.log('[htmlEditor.onButtonRemove] ', ident)
      const el = this.selectedElement.element;
      const parent = el.parentNode;

      // 1) vezmeme textový obsah
      const textNode = document.createTextNode(el.textContent);

      // 2) nahradíme element textovým uzlem
      parent.replaceChild(textNode, el);

      // 3) přesuneme caret ZA vložený text
      const range = document.createRange();
      const sel = window.getSelection();

      range.setStartAfter(textNode);
      range.collapse(true);

      sel.removeAllRanges();
      sel.addRange(range);

      this.selectedElement = {
        tagName: null,
        element: null,
      };

      //TODO update buttons

      this.updateButtons();
    },

    insertElement(elementInfo, el) {
      const range = this.savedRange;
      range.deleteContents();

      //mezera za
      /*
      const spaceTextNode = document.createTextNode(' ');
      range.insertNode(spaceTextNode);
      //console.log('dev insertElement SPACE IE', spaceTextNode)
*/
      range.insertNode(el);

      if(
          elementInfo.isWrap != true
      ) {
        range.collapse(false);
      }
      this.restoreCursorAfter(el);
    },

    insertText(
        text,
        moveCursor = true
    ) {
      if (!this.savedRange) {
        return false;
      }

      const range = this.savedRange;
      const textNode = document.createTextNode(text || '');

      range.deleteContents();
      range.insertNode(textNode);


      if(
          moveCursor
      ){
        range.setStartAfter(textNode);
        range.collapse(true);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        this.savedRange = range.cloneRange();
      }



      return true;
    },

    createHtmlElementDynamic(
        index,
        data,
    ) {
      //console.log('[htmlEditor.createHtmlElementDynamic]', index, data )
      if(!this.savedRange) return false;

      const range = this.savedRange;

      const element = document.createElement(data.tagName);
      element.setAttribute(
          this.config.attributes.element_typ_name,
          index
      );
      for(const a in data.render_attr) {
        element.setAttribute(a, data.render_attr[a]);
      }

      if(
          data.innerHTML
      ){
        element.innerHTML = data.innerHTML;
      }else{
        element.appendChild(range.extractContents());
      }

      if(data.child) {

        //console.log('[htmlEditor.createHtmlElementDynamic] child', data.child)
        /**/
        this.createChildHtml(
            element,
            data.child
        );
        //console.log('[htmlEditor.createHtmlElementDynamic] el', element)

        /*
        for(const child of data.child) {
          console.log('[htmlEditor.createHtmlElementDynamic] child', child)
        }
        */
      }

      //console.log('[htmlEditor.createHtmlElementDynamic] data', data)



      return element
    },



    createHtmlElement(
        index,
        data,
        attributes = {},
    ) {
      if(!this.savedRange) return false;

      const range = this.savedRange;

      const element = document.createElement(data.tagName);
      element.setAttribute(
          this.config.attributes.element_typ_name,
          index
      );

      if(
          this.dialog
          && this.dialog.display
          && this.dialog.wrapped
      ){
        //console.log('[htmlEditor.this.dialog.wrapped]', this.dialog.wrapped )
        element.innerHTML = this.dialog.wrapped;
      }else{
        if(
            data.isWrap == true
            && !data.child
        ) {
          element.appendChild(range.extractContents());
          //console.log('[htmlEditor.range] ',element,  range.extractContents() )
        }
      }

      if (data.params){
        for(const p in data.params){
          //console.log('[htmlEditor.params] ',p, data.params[p], )
          if(
              data.params[p].isRender
          ){
            element.setAttribute(p, data.params[p].value);
          }
        }
      }

      if (attributes){
        //console.log('[htmlEditor.createHtmlElement] attributes', attributes)
        for(const p in attributes){
          element.setAttribute(p, attributes[p]);
        }
      }


      //children TODO n-level
      if(data.child){
        this.createChildHtml(
            element,
            data.child
        );
      }
      return element;
    },

    createChildHtml(parentEl, data) {
      const range = this.savedRange;
      //console.log('[htmlEditor.createChildHtml type] ', typeof data);

      for(const child of data){
        //console.log('[htmlEditor.createChildHtml KID] ', child);
        const el = document.createElement(child.tagName);
        if(
            child.innerHtmlPlaceholder
        ){
          el.appendChild(range.extractContents());
        } else if(
            child.content
        ){
          el.innerHTML = child.content;
        }

        //attr
        if (child.params){
          for(const p in child.params){
            el.setAttribute(p, child.params[p]);
          }
        }

        //children
        if(
            child.child
        ) {
          this.createChildHtml(el, child.child);
        }
        parentEl.appendChild(el);
      }
    },

    onPaste(event) {
      event.preventDefault();

      const html = event.clipboardData.getData("text/html");
      const text = event.clipboardData.getData("text/plain");

      // pokud není HTML, vložíme čistý text
      if (!html) {
        document.execCommand("insertText", false, text);
        return;
      }

      // očistíme HTML
      const clean = this.cleanPastedHtml(html);

      // vložíme čisté HTML
      document.execCommand("insertHTML", false, clean);
    },

    cleanPastedHtml(html) {
      //console.log('[htmlEditor.cleanPastedHtml] ', html)

      const div = document.createElement("div");
      div.innerHTML = html;

      // 1) Odstranění komentářů
      const removeComments = (node) => {
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_COMMENT, null);
        const comments = [];

        let comment;
        while ((comment = walker.nextNode())) {
          comments.push(comment);
        }

        comments.forEach(c => c.remove());
      };

      removeComments(div);

      // 2) Odstranění style/font/data-* atributů
      const walker = document.createTreeWalker(div, NodeFilter.SHOW_ELEMENT, null);

      let el;
      while ((el = walker.nextNode())) {

        // odstranění id
        el.removeAttribute("id");

        // odstranění style
        el.removeAttribute("style");

        // odstranění font atributů
        el.removeAttribute("font");
        el.removeAttribute("face");
        el.removeAttribute("color");
        el.removeAttribute("size");

        // odstranění všech data-* atributů
        [...el.attributes].forEach(attr => {
          if (attr.name.startsWith("data-")) {
            el.removeAttribute(attr.name);
          }
        });
      }

      return div.innerHTML;
    },

    optimazeHtml() {
      let cleanContent = this.$refs.editorWysiwygBody.innerHTML
      //console.log("dev wysiwyg.optimazeHtml", cleanContent);

      cleanContent = this.cleanPastedHtml(cleanContent);
      cleanContent = this.removeEmptyElements(cleanContent);
      this.$refs.editorWysiwygBody.innerHTML = cleanContent;
      //this.updateCode();
      this.dialog.display = false; //pokud je otevreny dialog
      this.updateCode();
    },

    removeEmptyElements(html) {
      const div = document.createElement("div");
      div.innerHTML = html;

      const walker = document.createTreeWalker(
          div,
          NodeFilter.SHOW_ELEMENT,
          null
      );

      const toRemove = [];

      let node;
      while ((node = walker.nextNode())) {
        // ignorujeme self-closing tagy typu <img>, <br>, <hr>
        if (["IMG", "BR", "HR", "INPUT"].includes(node.tagName)) continue;

        // pokud element nemá žádné děti nebo jen whitespace
        const isEmpty =
            node.childNodes.length === 0 ||
            (node.childNodes.length === 1 &&
                node.childNodes[0].nodeType === Node.TEXT_NODE &&
                node.childNodes[0].textContent.trim() === "");

        if (isEmpty) {
          toRemove.push(node);
        }
      }

      // smažeme od konce, aby se walker nerozbil
      toRemove.reverse().forEach(n => n.remove());

      return div.innerHTML;
    },


    callElementAction(ident, action) {
      if (typeof this[action] === 'function') {
        this[action]();
      } else {
        console.log('Metoda  neexistuje.', ident, action);
      }
    },
    addRow() {
      const table = this.selectedElement.element.parentNode.parentNode;
      const tr = this.selectedElement.element.parentNode.cloneNode(true);
      const trSelf = this.selectedElement.element.parentNode;
      const tds = tr.querySelectorAll(':scope > td');
      tds.forEach((td, index) => {
        td.innerHTML = "&nbsp;";
      });
      trSelf.after(tr);

      this.setCursorToEnd(tr.cells[0])
    },

    addCol() {
      const table = this.selectedElement.element.closest('table');

      if(
          table
          && table.tagName.toLowerCase() == 'table'
      ){
        const tdIndex = this.selectedElement.element.cellIndex;
        const selfTr = this.selectedElement.element.closest('tr');
        const rows = table.querySelectorAll('tr');

        rows.forEach(row => {
          const newTd = document.createElement('td');
          //newTd.textContent = 'new-' + (tdIndex +1);
          const newIndex = tdIndex + 1;
          row.insertBefore(newTd, row.children[newIndex] || null);
          if(
              row == selfTr
          ) {
            this.setCursorToEnd(newTd)
          }
        });
      }
    },


    async copySourceToEditorCustom() {
      const cssText = await fetch("/css/custom.css").then(r => r.text());

      const cssDefinition = new CSSStyleSheet();
      cssDefinition.replaceSync(cssText);



      const foundContents = [];
      const sourceRegex = /\.source(?![a-zA-Z0-9_-])/;

      const walkRules = (rules) => {
        for (const rule of rules) {
          if (rule.selectorText && sourceRegex.test(rule.selectorText)) {
            // Získáme kompletní text pravidla včetně selektoru, např:
            // .source { .table { background-color: red; } }
            const fullText = rule.cssText.trim();

            // Najdeme index první otevírací závorky
            const firstBraceIndex = fullText.indexOf('{');

            if (firstBraceIndex !== -1) {
              // Odřízneme selektor a otevírací závorku "{"
              let content = fullText.substring(firstBraceIndex + 1);

              // Odřízneme poslední uzavírací závorku "}"
              if (content.endsWith('}')) {
                content = content.slice(0, -1);
              }
              const styleText = content.replace(/&\s*/g, '');
              foundContents.push(content.replace(/&\s*/g, ''))
            }
          }
          // Procházíme dál, pokud jsou pravidla vnořená v @media atd.
          else if (rule.cssRules) {
            walkRules(Array.from(rule.cssRules));
          }
        }
      };

      walkRules(Array.from(cssDefinition.cssRules));

      if (foundContents.length > 0) {
        const createdCss = new CSSStyleSheet();
        const sourceContent = foundContents.join(' ');

        createdCss.replaceSync(`
        .editor-body {
          ${sourceContent}
        }
      `);

        // 5) připojíme stylesheet jen pro tuto komponentu
        document.adoptedStyleSheets = [
          ...document.adoptedStyleSheets,
          createdCss
        ];
      }
    },

    getDefinitionFromElement(el) {
      let result = null;
      if(el.element){
        result = el.element.tagName.toLowerCase();

        if(
            el.element.getAttribute(this.config.attributes.element_typ_name)
        ) {
          result = el.element.getAttribute(this.config.attributes.element_typ_name);
          //console.log('[htmlEditor.getDefinitionFromElement] CLASS', el.element.getAttribute(this.config.attributes.element_typ_name))
        }
       return this.buttons[result];
      }
      return null;
    },

    onContextMenu(event) {
      const elementDefinition = this.getDefinitionFromElement(this.selectedElement);

      //console.log('[htmlEditor.onContextMenu] ', this.selectedElement.tagName)
      //console.log('[htmlEditor.onContextMenu] elementDefinition', elementDefinition)

      let items = []

      if(
          this.selectedElement
          && this.selectedElement.element
      ){
        let infoName = this.selectedElement.element.tagName.toLowerCase();
        //infoName += '.' + this.selectedElement.element.className;
        this.selectedElement.element.classList.forEach((className) => {
          const classForbidden = ['vue-app-highlighted-element',];
          if(
              !classForbidden.includes(className)
          ){
            infoName += '.' + className;
          }
        });

        items.push({
          label: infoName,
          icon: "bi-info-circle",
        });
      }


      if(
          elementDefinition
          && elementDefinition.dialog
      ) {
        //editace
        const ident = this.selectedElement.element.getAttribute(this.config.attributes.element_typ_name)
        items.push({
          label: this.$t('wysiwyg.action.general.contextMenu.edit'),
          icon: "bi-pen",
          onClick: () => this.elementEdit(this.selectedElement.element, ident, elementDefinition)
        });
      }

      items.push({
        label: this.$t('wysiwyg.action.general.contextMenu.remove'),
        icon: "bi-trash",
        onClick: () => this.elementRemove(this.selectedElement.element)
      });

      items.push({
        label: this.$t('wysiwyg.action.general.contextMenu.clean'),
        icon: "bi-eraser-fill",
        onClick: () => this.elementClean(this.selectedElement.element)
      });

      items.push({
        label: this.$t('wysiwyg.action.general.contextMenu.duplicate'),
        icon: "bi-copy",
        onClick: () => this.elementDuplicate(this.selectedElement.element)
      });
/*
      items.push({
        label: this.$t('wysiwyg.action.general.contextMenu.move_backward'),
        icon: "bi-chevron-bar-left",
        onClick: () => this.elementCursorMove('backward')
      });

      items.push({
        label: this.$t('wysiwyg.action.general.contextMenu.move_forward'),
        icon: "bi-chevron-bar-right",
        onClick: () => this.elementCursorMove('forward')
      });
    */


      if(this.selectedElement.tagName == 'li') {
        const listItems = [
          { divide: true }, // Rozdělovník
          {
            label: "Pridat polozku",
            icon: "bi-plus",
            onClick: () => this.elementListAdd()
          },
          {
            label: "Smazat polozku",
            icon: "bi-trash",
            onClick: () => this.elementListLiRemove()
          },
        ];
        items = [...items, ...listItems];
      }else if(this.selectedElement.tagName == 'td') {
        const tableItems = [
          { divide: true }, // Rozdělovník
          {
            label: this.$t('wysiwyg.action.table.contextMenu.col.title'),
            icon: "bi-layout-three-columns",
            children: [
              { label: this.$t('wysiwyg.action.table.contextMenu.col.add'), icon: "bi-plus", onClick: () => this.addCol()  },
              { label: this.$t('wysiwyg.action.table.contextMenu.col.remove'), icon: "bi-trash", onClick: () => this.elementTableRemoveCol() },
            ]
          },
          {
            label: this.$t('wysiwyg.action.table.contextMenu.row.title'),
            icon: "bi-list",
            children: [
              { label: this.$t('wysiwyg.action.table.contextMenu.row.add'), icon: "bi-plus", onClick: () => this.addRow() },
              { label: this.$t('wysiwyg.action.table.contextMenu.row.remove'), icon: "bi-trash", onClick: () => this.elementTableRemoveRow() },
            ]
          }

        ]
        items = [...items, ...tableItems];
      }else if(this.selectedElement.tagName == 'p') {
        const pItems = [
          { divide: true }, // Rozdělovník
          {
            label: this.$t('wysiwyg.action.p.contextMenu.createBefore.title'),
            icon: "bi-chevron-bar-up",
            onClick: () => this.elementParagraphCreate(this.selectedElement.element, 'before')
          },
          {
            label: this.$t('wysiwyg.action.p.contextMenu.createAfter.title'),
            icon: "bi-chevron-bar-down",
            onClick: () => this.elementParagraphCreate(this.selectedElement.element, 'after')
          },
          { divide: true }, // Rozdělovník
          {
            label: this.$t('wysiwyg.action.p.contextMenu.align_left.title'),
            icon: "bi-justify-left",
            onClick: () => this.elementSetClass(this.selectedElement.element, ['text-start'], ['text-center', 'text-end'])
          },
          {
            label: this.$t('wysiwyg.action.p.contextMenu.align_center.title'),
            icon: "bi-text-center",
            onClick: () => this.elementSetClass(this.selectedElement.element, ['text-center'], ['text-start', 'text-end'])
          },
          {
            label: this.$t('wysiwyg.action.p.contextMenu.align_right.title'),
            icon: "bi-justify-right",
            onClick: () => this.elementSetClass(this.selectedElement.element, ['text-end'], ['text-center', 'text-start'])
          },
        ]
        items = [...items, ...pItems];
      }else if(
          this.selectedElement.tagName == 'a'
      ) {

        const href = {
          link: this.selectedElement.element.getAttribute('href'),
          display: this.trimString(this.selectedElement.element.getAttribute('href'), 50)
        };

        const linkItems = [
          { divide: true }, // Rozdělovník
          {
            label: this.$t('wysiwyg.action.link.contextMenu.visit')+ ": " + href.display,
            icon: "bi-globe",
            onClick: () => this.elementLinkOpen(href.link)
          },
        ]
        //DEV
        items = [...items, ...linkItems];
      }


      // Zamezíme výchozímu menu prohlížeče
      if(
          items
          && items.length > 0
      ) {
        event.preventDefault();

        // Vyvoláme menu přímo přes JS
        ContextMenu.showContextMenu({
          x: event.clientX,
          y: event.clientY,
          items: items,
        });
      }

    },

     trimString(text, maxDelka = 100) {
        if (text.length > maxDelka) {
          return text.substring(0, maxDelka) + '...';
        }
        return text;
    },

    elementParagraphCreate(element, way = 'after') {
      console.log('[htmlEditor.elementParagraphCreate] ', element, way)

      const parent = element.parentNode;
      const p = document.createElement('p');
      p.innerHTML = '&nbsp;';

      if(way == 'after') {
        //p.innerHTML = '[p after]';
        element.after(p);
      }else if(way == 'before'){
        //p.innerHTML = '[p before]';
        parent.insertBefore(p, this.selectedElement.element);
      }

      this.setCursorToEnd(p)

    },
    elementEdit(element, ident, definition = null) {
      //const definition = this.getDefinitionFromElement(element);
      this.openDialog(
          ident,
          definition
      );
      this.updateDialogValues(definition.dialog.inputs);
      //console.log('[htmlEditor.elementEdit] element', ident, definition)

    },
    elementEditX(element) {
      //console.log('[htmlEditor.elementEdit] element', element.element)

      const tagName = element.element.tagName.toLowerCase();
      const buttonIdent = element.element.getAttribute(this.config.attributes.element_typ_name);

      //console.log('[htmlEditor.elementEdit] tagName', tagName)
      //console.log('[htmlEditor.elementEdit] buttonIdent', buttonIdent)

      let buttonData;
      let buttonIndex;
      if(this.buttons[buttonIdent]) {
        buttonData = this.buttons[buttonIdent];
        buttonIndex = buttonIdent;
      }else if(this.buttons[tagName]) {
        buttonData = this.buttons[tagName];
        buttonIndex = tagName;
      }


      if(
          buttonIndex
          && buttonData
          && buttonData.dialog
      ){
        console.log('[htmlEditor.elementEdit] buttonData OK', buttonIndex, buttonData)
        console.log('[htmlEditor.elementEdit] selectedElement', this.selectedElement)
        this.saveElementRange(element.element, false, true);

        console.log('[htmlEditor.openDialog] EDIT CALL', buttonIndex, buttonData)
        /*
        this.openDialog(
            buttonIndex,
            buttonData
        );
      */
      }

      //


    },

    elementDuplicate(element) {
      const clone = element.cloneNode(true)
      element.after(clone);

    },

    elementSetClass(element, add = {}, remove = {}) {

      if(
          add
          && add.length > 0
      ){
        for(const a of add) {
          element.classList.add(a);
          //console.log('[htmlEditor.elementSetClass] add', a)
        }
      }

      if(
          remove
          && remove.length > 0
      ){
        for(const r of remove) {
          element.classList.remove(r);
          //console.log('[htmlEditor.elementSetClass] remove', r)
        }
      }

    },
    elementRemove(element) {

//      console.log('[htmlEditor.elementRemove] LI', element.tagName.toLowerCase())

      if(
          element
      ){
        if (
            confirm("Opravdu chcete smazat tento element?") === true
        ){

          if (element.tagName.toLowerCase() == 'li') {
            element.parentNode.remove();

          }else if(element.tagName.toLowerCase() == 'td'){
            const table = this.selectedElement.element.closest('table');
            if(table) {
              table.remove();
            }

          }else{
            element.remove();
          }

          this.selectedElement = {
            tagName: null,
            element: null,
          }
        };
      }
    },
    elementClean(element) {
      if(
          element
      ){
        if (
            confirm("Opravdu chcete odstranit formatovani elementu?") === true
        ) {
          //this.setCursorToEnd(element)
          element.replaceWith(element.innerHTML);
          //TODO cursor


        }
      }
    },

    elementTableRemove(){
      const table = this.selectedElement.element.closest('table');
      if(
          table
      ){
        if (
            confirm("Opravdu chcete smazat tabulku?") === true
        ){
            table.remove();
        };
      }
    },

    elementTableRemoveRow(){
      const tr = this.selectedElement.element.closest('tr');
      if(
          tr
      ){
        if (
            confirm("Opravdu chcete smazat radek?") === true
        ){
          tr.remove();
        };
      }
    },

    elementTableRemoveCol(){
      if (
          confirm("Opravdu chcete smazat tento sloupec?") === true
      ){
        const table = this.selectedElement.element.closest('table');
        const tdIndex = this.selectedElement.element.cellIndex;
        const rows = table.querySelectorAll('tr');
        rows.forEach(row => {
          row.children[tdIndex].remove();
        })
      };
    },

    elementListLiRemove() {
      if (
          confirm("Opravdu chcete smazat tuto polozku?") === true
      ){
        this.selectedElement.element.remove();
        this.selectedElement = {
          tagName: null,
          element: null,
        };
      };
    },
    elementListAdd() {
      const list = this.selectedElement.element.closest('ol');
      if(
          !list
      ) {
        const list = this.selectedElement.element.closest('ul');
      }
      const li = document.createElement('li');
      //list.append(li)
      this.selectedElement.element.after(li);

    },
    elementListRemove() {
      const list = this.selectedElement.element.closest('ol');
      if(
          !list
      ) {
        const list = this.selectedElement.element.closest('ul');
      }

      if(
          list
      ){
        if (
            confirm("Opravdu chcete smazat seznam?") === true
        ){
          list.remove();
        };
      }
    },

    async elementLinkOpen(url) {
      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.getApiConfig('general.openLink.path') + '?url=' + url + '&lang_code=' + this.langCode,
        method: this.getApiConfig('general.openLink.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(
            res.data.response.urlResponse
        ){
          window.open(res.data.response.urlResponse, '_blank', 'noopener,noreferrer');
        }
          console.log('[htmlEditor.elementLinkOpen] ', res.data.response.urlResponse)

      }).catch((err) => {
        this.err = "openLink nenalezen, kontaktujte spravce"
      })

      //todo volani service
      //window.open(url, '_blank', 'noopener,noreferrer');
    },


    elementCursorMove(way = 'forward') {
      //forward, backward,
      console.log('[htmlEditor.elementLinkCursorMove] way', way)
      console.log('[htmlEditor.elementLinkCursorMove] element', this.selectedElement.element)

      const element = this.selectedElement.element;

      if (!element || !element.parentNode) {
        console.warn("Není vybrán žádný element nebo chybí rodič.");
        return;
      }

      const parent = element.parentNode;

      // Získáme index vybraného elementu v rámci jeho rodiče
      const index = Array.from(parent.childNodes).indexOf(element);

      if (index !== -1) {
        const selection = window.getSelection();
        const range = document.createRange();

        // Nastavíme pozici range přesně na index před vybraným elementem
        range.setStart(parent, index);
        range.collapse(true); // collapse(true) posune kurzor na začátek rozsahu (před element)

        // Vyčistíme předchozí výběr a aplikujeme nový
        selection.removeAllRanges();
        selection.addRange(range);

        // Volitelné: Pokud je div contenteditable, hodí se na něj zavolat focus()
        // parent.focus();
      }

    },


    //------- OLD ----------------------------------
    prefillData() {
      if(this.modelValue) {
        this.editorObj.data = {
          wysiwyg: this.modelValue,
          code: this.modelValue,
        }
        if(this.$refs.editorWysiwygBody) {
          this.$refs.editorWysiwygBody.innerHTML = this.editorObj.data.wysiwyg;
        }
        this.inputModel = this.modelValue;
      }
    },

    loadCustomButtons() {
      if(this.editorType) {
        //console.log('[htmlEditor.loadCustomButtons] this.editorType', this.getApiConfig('wysiwyg.buttons.path') +'?type=' + this.editorType)
        let formData = new FormData();
        formData.append('type', this.editorType);
        formData.append('buttons', JSON.stringify(this.buttonsDefinition));
        //formData.append('special_buttons', JSON.stringify(this.specialsDefinition));
        formData.append('special_buttons', JSON.stringify(this.specialsDefinition));


        axios.defaults.baseURL = this.getBaseRoot();
        axios({
          method: 'post',
          url: this.getApiConfig('wysiwyg.buttons.path') +'?type=' + this.editorType,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          //console.log('[htmlEditor.loadCustomButtons] RES.buttons',  res.data.response)
          //console.log('[htmlEditor.loadCustomButtons] RES', res.data)
          if(res.data.status) {
            this.buttons = res.data.response.buttons;
            this.specialButtons = res.data.response.special_buttons;
          }
        }).catch(function(err){
          console.log('[htmlEditor.loadCustomButtons] ERR',  err )
        })
      }

    },

    updateCode(){
      this.editorObj.data.wysiwyg = this.$refs.editorWysiwygBody.innerHTML;
      this.editorObj.data.code = this.$refs.editorWysiwygBody.innerHTML;
    },

    closeDialog(){
      //this.dialog.display = false;
      this.dialog.display = false;
      this.dialog.definiton = null;
      this.dialog.index = null;
      this.dialog.validation = null;
    },

    isDisplaySpecialButton(ident, method = null) {
      //console.log('[htmlEditor.isDisplaySpecialButton]', ident, method)

      if(
          this.displaySpecials[ident]
      ) {
        return true;
      } else {
        return false;
      }
    },

    clickSpecialButton(ident) {
      if(typeof this[ident] == "function") {
        this[ident]();
      }else{
        console.log('[htmlEditor.clickSpecialButton] NEEXISTUJE funkce', ident)
      }
    },
    // - waste------------------

    toggleFullscreen () {
      const element = this.$refs.editorWrap;

      if(this.displaySpecials.fullscreenToggleOn) {
        if (!document.fullscreenElement) {
          console.log('onToggleFullscreen entry', this.$refs.editorWrap)
          this.$refs.editorWrap.classList.add('fullscreen-wrap');
          element.requestFullscreen().catch(err => {
            //this.displaySpecials.fullscreenToggleOn = true;
            //this.displaySpecials.fullscreenToggleOff = false;
            console.error(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
          });
        } else {
          document.exitFullscreen();
          console.log('onToggleFullscreen exit' )
          this.$refs.editorWrap.classList.remove('fullscreen-wrap');
          //this.displaySpecials.fullscreenToggleOn = true;
          //.displaySpecials.fullscreenToggleOff = false;
        }
      }else{
        console.log('onToggleFullscreen exit 2')
        document.exitFullscreen();
        this.$refs.editorWrap.classList.remove('fullscreen-wrap');
        //this.displaySpecials.fullscreenToggleOn = true;
        //this.displaySpecials.fullscreenToggleOff = false;
      }

      this.displaySpecials.fullscreenToggleOn = !this.displaySpecials.fullscreenToggleOn;
      this.displaySpecials.fullscreenToggleOff = !this.displaySpecials.fullscreenToggleOff;
    },

    generateRandomString() {
      const length = 20;
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;
    },

    switchHelp() {
      this.helpObj.display  = !this.helpObj.display;
      //console.log('[htmlEditor.switchHelp]', this.searchObj)
    },
    isHelpObj() {
      let status = false;
      let structure = {
        // 'dev': null,
      };




      if(this.buttons){
        const buttonsIdent = 'buttons'
        const specialIdent = 'specials'
        structure[buttonsIdent] = {
          title: 'wysiwyg.help.title',
          ico: null,
          display: true,
          items: {}
        }

        structure[specialIdent] = {
          title: 'wysiwyg.section.special.title',
          ico: null,
          display: false,
          items: {},

        }

        structure[buttonsIdent].items['general'] = {
          title: 'wysiwyg.help.general.title',
          ico: 'bi bi-plus',
          content: 'wysiwyg.help.general.content',
          display: false,
        }

        //btns
        for(const i in this.buttons) {
          if(this.buttons[i].help) {
            structure[buttonsIdent].items[i] = {
              title: this.buttons[i].title,
              ico: this.buttons[i].ico,
              content: this.buttons[i].help,
              display: false,
            }
            status = true;
          }
        }


        //specials
        for(const i in this.specialsDefinition) {
          if(this.specialsDefinition[i].help) {
            structure[specialIdent].items[i] = {
              title: this.specialsDefinition[i].title,
              ico: this.specialsDefinition[i].ico,
              content: this.specialsDefinition[i].help,
              display: false,
            }
            status = true;
          }
        }

      }

      //check
      for(const s in structure){
        if(Object.keys(structure[s].items).length == 0 ){
          delete structure[s];
        }
      }

      this.helpObj.data = structure
      this.displaySpecials.help = status
    },

    toogleHelpItem(section, item = null) {

      for(const s in this.helpObj.data){
        this.helpObj.data[s].display = false;



        if(s == section) {
          this.helpObj.data[s].display = true;
          if(
              item
              && Object.keys(this.helpObj.data[s].items).length > 0
          ){
            for(const i in this.helpObj.data[s].items){
              this.helpObj.data[s].items[i].display = false;
              if(s == section && i == item) {
                this.helpObj.data[s].items[i].display = true;
              }
            }
          }
        }
      }
    },

    handleFullscreenChange() {
      // Pokud document.fullscreenElement existuje, převede se na true, jinak na false
      const isFullscreen = !!document.fullscreenElement

      if (!isFullscreen) {
        this.$refs.editorWrap.classList.remove('fullscreen-wrap');
      }
    },
  },
  watch: {
    "savedRange": {
      handler() {
        this.updateButtons();
      },
      deep: true,
      immediate: true
    },
    "editorObj.data.code": {
      handler(newVal, oldVal) {
        if(newVal !== null) {
          if(newVal == '') {
            newVal = null;
          }
          this.$emit('update:modelValue', newVal)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>